export const isAnchorOrDocumentLink = (data) =>
	data?.includes("#") || data?.includes("static");

export const isFelixMobileUrl = (data) =>
	data?.includes("//felixmobile.com.au") ||
	data?.includes("//www.felixmobile.com.au");

export const isWebBuyLink = (data) => data?.includes("buy");

export const filterUrlPath = (data) =>
	data?.substring(data.lastIndexOf(".com.au") + 7);
